import { NgModule } from "@angular/core";
import { SplitViewInternComponent } from "./pages/split-view-intern/split-view-intern";
import { SplitViewComponent } from "./pages/split-view/split-view.page";
import { SplitViewRevisionsComponent } from "./pages/split-view-revisions/split-view-revisions.page";
import { SplitViewSideHeadComponent } from "./components/split-view-side-head/split-view-side-head.component";
import { SplitViewOldComponent } from "./pages/split-view-old/split-view-old.page";
import { SplitViewInternRevisionsComponent } from "./pages/split-view-intern-revisions/split-view-intern-revisions";
import { ProofreadingInfoComponent } from "./components/proofreading-info/proofreading-info.component";
import { SplitViewRoutingModule } from "./split-view.routing.module";
import { CommonModule } from "@angular/common";
import { MaterialModule } from "../material.module";
import { SharedModule } from "../shared/shared.module";
import { ProductionTextsComponent } from "./components/production-texts/production-texts.component";
import { MembersAssessmentsComponent } from "./components/members-assessments/members-assessments.component";
import { StateMachineExternComponent } from "./components/state-machine-extern/state-machine-extern.component";
import { StateMachineInternComponent } from "./components/state-machine-intern/state-machine-intern.component";
import { ApprovalProofreadingCompareComponent } from "./components/approval-proofreading-compare/approval-proofreading-compare.component";
import { InternProofreadingCompareComponent } from "./components/intern-proofreading-compare/intern-proofreading-compare.component";
import { InfoSkeleton } from "./components/info-skeleton/info-skeleton.component";
import { MembersProofreadingModal } from "./components/members-proofreading-modal/members-proofreading-modal.component";
import { MembersProofreadingComponent } from "./components/members-proofreading/members-proofreading.component";
import { FlowsVersionSelectorComponent } from "./components/flows-version-selector/flows-version-selector.component";
import { HistoryDetailComponent } from "./components/history-detail/history-detail.component";
import { NutritionalTableComponent } from "./components/nutritional-table/nutritional-table.component";
import { ProjectProofreadingsStatusesComponent } from "./components/project-proofreadings-statuses/project-proofreadings-statuses.component";
import { AddFieldDialogComponent } from "./components/dialog/add-field-dialog/add-field-dialog.component";
import { ApproveDialogComponent } from "./components/dialog/approve-dialog/approve-dialog.component";
import { SelectFlowDialogComponent } from "../shared/components/dialog/select-flow/select-flow.component";
import { WarnProdFlowDialogComponent } from "../shared/components/dialog/warn-prod-flux/warn-prod-flux.component";
import { MembersProofreadingCrudModal } from "./components/members-proofreading-crud-modal/members-proofreading-crud-modal.component";
import { ProjectMembersComponent } from "../project-creation/components/project-members/project-members.component";
import { ProjectModule } from "../project-creation/project.module";
import { ProofreadingAttachmentComponent } from "./components/proofreading-attachment/proofreading-attachment.component";

@NgModule({
    declarations: [
        SplitViewInternComponent,
        SplitViewComponent,
        SplitViewInternRevisionsComponent,
        SplitViewRevisionsComponent,
        SplitViewSideHeadComponent,
        SplitViewOldComponent,
        ProofreadingInfoComponent,
        MembersAssessmentsComponent,
        MembersProofreadingModal,
        ProjectMembersComponent,
        MembersProofreadingCrudModal,
        StateMachineExternComponent,
        StateMachineInternComponent,
        ApprovalProofreadingCompareComponent,
        InternProofreadingCompareComponent,
        InfoSkeleton,

        AddFieldDialogComponent,
        ApproveDialogComponent,

        ProjectProofreadingsStatusesComponent,
        NutritionalTableComponent,
        HistoryDetailComponent,
        MembersProofreadingComponent,
        FlowsVersionSelectorComponent,
        ProductionTextsComponent,
        SelectFlowDialogComponent,
        WarnProdFlowDialogComponent,
        ProofreadingAttachmentComponent
    ],
    imports: [
        SplitViewRoutingModule,
        MaterialModule,
        SharedModule,
        CommonModule,
    ],
    exports: [
        ProjectProofreadingsStatusesComponent,
        HistoryDetailComponent,
        FlowsVersionSelectorComponent,
        ProductionTextsComponent,
        ProjectMembersComponent,
    ],
    providers: [],
    bootstrap: []
})
export class SplitViewModule { }
